import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';
import { getMyHomeLink } from './helpers/getMyHomeLink';
import { trackMyHomeTrapClick, trackMyHomeTrapShow } from './helpers/tracking';
import { MyHomeTrapBanner } from '../../components/MyHomeTrap';
import { selectNewbuildingAddress } from '../../selectors/newbuilding/selectNewbuildingAddress';
import { selectMyHomeShowTrap } from '../../selectors/myHome/selectMyHomeShowTrap';

export const MyHomeTrap: React.FC = () => {
  const showTrap = useSelector(selectMyHomeShowTrap);
  const address = useSelector(selectNewbuildingAddress);

  const link = getMyHomeLink(address);

  if (!showTrap) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackMyHomeTrapShow} triggerOnce>
      <MyHomeTrapBanner link={link} onClick={trackMyHomeTrapClick} />
    </ActionAfterViewObserver>
  );
};

MyHomeTrap.displayName = 'MyHomeTrap';
